import { Box } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import idframe from '../../assets/images/id_frame.png';
import idframe2 from '../../assets/images/sun_back.png';
import idframe3 from '../../assets/images/sri_front.png';
import idframe4 from '../../assets/images/sri_back.png';

const ImageLoaderComponent = React.memo(({ rowsSelect, addToRefs, setLoader, idvalue }) => {
  const imgElements = useRef([]);

  const signElements = useRef([]);

  console.log(rowsSelect);

  useEffect(() => {
    let isMounted = true; // Flag to track component mounting state

    const loadImage = async (val, index) => {
      const imageId = getImageIdFromUrl(val?.img ? val?.img : "https://skyschool.s3.amazonaws.com/idphoto1723733221716");
      const signId = getImageIdFromUrl(val?.sign ? val?.sign : "https://skyschool.s3.amazonaws.com/idphoto1723733221716");
      const blob = await urlToBlob(imageId);
      const signblob = await urlToBlob(signId);

      if (blob && isMounted) {
        const blobUrl = URL.createObjectURL(blob);
        const signUrl = URL.createObjectURL(signblob);
        const imgElement = imgElements.current[index];
        const signElement = signElements.current[index];

        if (imgElement) {
          imgElement.src = blobUrl || '';
          signElement.src = signUrl || '';
        } else {
          console.error(`Element with ID imgElement${index} not found.`);
        }
        if(index === rowsSelect.length-1){
          setLoader(false);
        }
      }
    };

    if (rowsSelect.length > 0) {
      rowsSelect.forEach((val, index) => {
        loadImage(val, index);
        console.log(index);
      });
    }

    return () => {
      isMounted = false; // Clean up the effect when the component unmounts
    };
  }, [rowsSelect]);

  const urlToBlob = async (imageId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/proxy/${imageId}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.error('Error fetching the image:', error);
    }
  };

  const getImageIdFromUrl = (url) => {
    if (url) {
      const urlObj = new URL(url);
      const pathSegments = urlObj.pathname.split('/');
      return pathSegments[pathSegments.length - 1];
    }
  };

  return (
    <Box sx={{display:'flex', gap: 2, flexWrap:'wrap'}}>
      {rowsSelect.map((val, index) => (
        <>
        <Box ref={addToRefs} width='8cm' height='13cm' sx={{ marginBottom:'40px', position:'relative', minWidth:'8cm'}}>
      <img src={idvalue === "sun" ? idframe : idframe3} alt='idframe' width='100%' height='100%'></img>
        <Box sx={{position:'absolute', left:'41%', top:'48%', transform:'translate(-50%, -50%)', zIndex: -1, borderRadius:'15px', border:'5px solid #fff', width:'100px', height:'150px'}}>
        <img
          id={`imgElement${index}`}
          ref={(el) => (imgElements.current[index] = el)} // Save the reference
          alt={`Image ${index}`}
          key={index}
          style={{position:'absolute', width:'155%', filter:'brightness(130%)'}}
        />
      </Box>
      <h1 style={{position:'absolute', left:'50%', top:'78%',transform:'translate(-50%, -50%)' , color:'#000', width:'90%', textAlign:'center', textTransform:'uppercase', fontSize:'20px'}}>{val?.name}</h1>
      <h2 style={{position:'absolute', left:'50%', top:'84.7%',transform:'translate(-50%, -50%)' , color:'#212121ff', fontSize:'15px',  width:'90%', textAlign:'center', fontWeight:'500', textTransform:'uppercase'}}>Emp No: {val?.std}</h2>
    </Box>
            <Box ref={addToRefs} width='8cm' height='13cm' sx={{ marginBottom:'40px', position:'relative', minWidth:'8cm'}}>
      <img src={idvalue === "sun" ? idframe2 : idframe4} alt='idframe' width='100%' height='100%'></img>
        <Box sx={{position:'absolute', left:'23%', top:'86%', transform:'translate(-50%, -50%)', zIndex: 1, borderRadius:'15px', border:'5px solid #fff', width:'40px', height:'50px'}}>
        <img
          id={`signElement${index}`}
          ref={(el) => (signElements.current[index] = el)} // Save the reference
          alt={`Sign ${index}`}
          key={index}
          style={{position:'absolute', width:'155%', filter:'brightness(130%)'}}
        />
      </Box>
      <h2 style={{position:'absolute', left:'70%', top:'6.4%',transform:'translate(-50%, -50%)' , color:'#212121ff', fontSize:'14px',  width:'90%', textAlign:'center', fontWeight:'600', textTransform:'uppercase'}}>{val?.dob}</h2>
      <h2 style={{position:'absolute', left:'65%', top:'13%',transform:'translate(-50%, -50%)' , color:'#212121ff', fontSize:'14px',  width:'90%', textAlign:'center', fontWeight:'600', textTransform:'uppercase'}}>{val?.bloodgroup}</h2>
      <h2 style={{position:'absolute', left:'50%', top:'61%',transform:'translate(-50%, 0%)' , color:'#212121ff', fontSize:'13px',  width:'90%', textAlign:'center', fontWeight:'600'}}>{val?.address1} <br/> Mob No: {val.phonenumber}</h2>
    </Box>
    </>
      ))}
</Box>
  );
});

export default ImageLoaderComponent;
